/**
 * Pure envelope builders for the `forget_memory` confirmation round-trip
 * (IMEM-19, COP-105). The produced JSON string is dispatched verbatim as a
 * follow-up user chat message; the runtime's forget-envelope handler validates
 * it against `ForgetMemoryEnvelopeSchema`
 * (`packages/shared/src/schemas/memory.ts`) and resolves the recorded pending
 * forget suggestion before soft-deleting.
 *
 * BINDING: the confirm/dismiss envelopes carry ONLY the `suggestionId` — the
 * server holds the whole binding (the exact memory ids/content/scope) in its
 * in-process pending-forget store, so nothing consequential is echoed from the
 * client. A delete must never trust the client echo. The card must never
 * re-derive or send the memory ids / content / scope.
 */
/** `{ kind: 'forget_confirm', suggestionId }` as JSON. */
export function buildForgetConfirmEnvelope(suggestionId) {
    return JSON.stringify({
        kind: 'forget_confirm',
        suggestionId,
    });
}
/** `{ kind: 'forget_dismiss', suggestionId }` as JSON. */
export function buildForgetDismissEnvelope(suggestionId) {
    return JSON.stringify({
        kind: 'forget_dismiss',
        suggestionId,
    });
}
//# sourceMappingURL=forget-memory-envelope.js.map